import { render, staticRenderFns } from "./IconSvgSCRLAServSafe.vue?vue&type=template&id=75d2b0c2&scoped=true&"
import script from "./IconSvgSCRLAServSafe.vue?vue&type=script&lang=js&"
export * from "./IconSvgSCRLAServSafe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d2b0c2",
  null
  
)

export default component.exports